"use client"
import { Toast, ToastTitle, ToastDescription, ToastAction, ToastClose } from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

export default function ToastsContainer() {
  const { toasts } = useToast()
  return (
    <>
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast}>
          <ToastTitle>{toast.title}</ToastTitle>
          {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
          {toast.action && <ToastAction altText="Action">{toast.action}</ToastAction>}
          <ToastClose />
        </Toast>
      ))}
    </>
  )
}